import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Img1 from "./Image/Magazine/2.jpg";
import Img2 from "./Image/Magazine/3.jpg";
import Img3 from "./Image/Magazine/4.jpg";

const stores = [
  {
    title: "Магазин на Ивановской, 6/4",
    address: "Владивосток, ул. Ивановская 6/4",
    phone: "+7 914 687-64-64",
    hours: ["ПН-ПТ: 10:00–20:00", "СБ-ВС: 10:00–18:00"],
    image: Img1,
    map: {
      src: "https://yandex.ru/map-widget/v1/?indoorLevel=1&ll=131.934246%2C43.110922&mode=search&oid=163237306314&ol=biz&z=16.98",
      link: "https://yandex.ru/maps/org/xiaomi/163237306314/?utm_medium=mapframe&utm_source=maps",
      label: "Mi64 на Ивановской",
    },
    emptyLine: true,
  },
  {
    title: "Магазин на 100-летия Владивостоку, 43",
    address: "Владивосток, пр-т 100-летия Владивостоку, 43",
    phone: "+7 994 007-64-64",
    hours: ["ПН-ПТ: 10:00–20:00", "СБ-ВС: 10:00–18:00"],
    image: Img2,
    map: {
      src: "https://yandex.ru/map-widget/v1/?ll=131.907754%2C43.151859&mode=search&oid=161189667255&ol=biz&z=16.98",
      link: "https://yandex.ru/maps/org/mi64/161189667255/?utm_medium=mapframe&utm_source=maps",
      label: "Mi64 на 100-летия Владивостоку",
    },
  },
  {
    title: "Магазин на Некрасовской 49(а) «ТЦ Море»",
    address: "Владивосток, ул. Некрасовская 49(а), ТЦ Море",
    phone: "+7 902 488-64-64",
    hours: ["ПН-ВС: 10:00–21:00"],
    image: Img3,
    map: {
      src: "https://yandex.ru/map-widget/v1/?ll=131.909317%2C43.127426&mode=search&oid=42823221982&ol=biz&z=16.98",
      link: "https://yandex.ru/maps/org/mi64/42823221982/?utm_medium=mapframe&utm_source=maps",
      label: "Xiaomi ТЦ Море",
    },
    emptyLine: true,
  },
];

const StoreCard = ({ store, animate }) => (
  <div className={`bg-white rounded-2xl shadow-md overflow-hidden flex flex-col h-full transition-all duration-500 ease-out ${animate ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
    <div className="h-[220px] bg-gray-200 flex items-center justify-center overflow-hidden">
      <img src={store.image} alt={store.title} className="object-cover w-full h-full" draggable={false} />
    </div>
    <div className="flex flex-col flex-1 justify-between p-6">
      <div>
        <h2 className="font-bold text-xl mb-2">{store.title}</h2>
        <p className="text-gray-600 mb-1">{store.address}</p>
        <p className="text-gray-600 mb-1">
          <a href={`tel:${store.phone.replace(/[^+\d]/g, "")}`} className="text-orange-600 hover:underline">
            {store.phone}
          </a>
        </p>
        <div className="text-gray-500 text-sm mb-3">
          {store.hours.map((h, i) => (
            <div key={i}>{h}</div>
          ))}
        </div>
        {store.emptyLine && <div className="h-6"></div>}
      </div>
      <div className="rounded-lg overflow-hidden border border-gray-200 shadow-sm mt-2 flex-shrink-0">
        <iframe
          src={store.map.src}
          width="100%"
          height="220"
          frameBorder="0"
          allowFullScreen
          title={store.map.label}
          style={{ border: "none" }}
        />
      </div>
      <div className="text-xs text-right mt-1">
        <a href={store.map.link} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
          {store.map.label}
        </a>
      </div>
    </div>
  </div>
);

const About = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <div className="bg-[#f6f6f6] min-h-screen pb-12">
      <h1 className="text-3xl font-bold text-center my-8">Магазины</h1>
      <div className="hidden md:grid max-w-7xl mx-auto grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-2">
        {stores.map((store, idx) => (
          <StoreCard store={store} key={idx} animate={mounted} />
        ))}
      </div>
      <div className="block md:hidden px-2">
        <Swiper spaceBetween={16} slidesPerView={1} style={{ paddingBottom: "2rem" }}>
          {stores.map((store, idx) => (
            <SwiperSlide key={idx}>
              <StoreCard store={store} animate={mounted} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default About;
